import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const getEvents = () => axios.get(`${API}/events`).then((r) => r.data);
export const getPublicEvents = () => axios.get(`${API}/public/events`).then((r) => r.data);
export const getPublicEventsPast = () => axios.get(`${API}/public/events/past`).then((r) => r.data);
export const getResources = () => axios.get(`${API}/resources`).then((r) => r.data);
export const sendContact = (payload) => axios.post(`${API}/contact`, payload).then((r) => r.data);
export const registerVisit = (visitorId) => axios.post(`${API}/visit`, { visitor_id: visitorId }).then((r) => r.data);

// ---- Área dos Trabalhadores (sessão via cookie httpOnly; Authorization como fallback em testes) ----
export const wapi = axios.create({ baseURL: API, withCredentials: true });
wapi.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("workers_token"); // fallback para testes automatizados
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
